<template>
  <div
    class="field"
    :style="{ '--form-item-width': grid.Cols, '--form-item-height': grid.Rows, '--form-item-start': grid.Offset }"
  >
    <label :for="id" class="field__label">
      <slot></slot>
    </label>

    <div class="table-wrapper" v-if="data">
      <div class="border">
        <label style="font-weight: bold; width: 100%; margin-bottom: 0.5rem;">Från</label>
        <table class="no-padding no-hover">
          <thead>
            <tr>
              <th>Placering</th>
              <th>Konto</th>
              <th style="width: 200px">Procent</th>
              <th>Belopp</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data_from" :key="index">
              <td>
                <fieldSelect
                  :key="uniqueid + '-from-instrument-' + index + '-select'"
                  :id="uniqueid + '-from-instrument-' + index + '-select'"
                  :grid="{ Cols: '100%', Rows: 1, Offset: 0 }"
                  :nativeSearch="true"
                  :options="instruments"
                  :value="item.InstrumentID"
                  @input="setField('From', index, 'InstrumentID')($event)"
                  @nextInput="focusNextInput"
                ></fieldSelect>
              </td>
              <td>
                <fieldSelect
                  :key="uniqueid + '-from-account-' + index + '-select'"
                  :id="uniqueid + '-from-account-' + index + '-select'"
                  :grid="{ Cols: '100%', Rows: 1, Offset: 0 }"
                  :nativeSearch="true"
                  :readonly="true"
                  :options="getInstrumentAccounts(item.InstrumentID)"
                  :value="item.AccountID"
                  @input="setField('From', index, 'AccountID')($event)"
                  @nextInput="focusNextInput"
                ></fieldSelect>
              </td>
              <td>
                <FieldPercent
                  class="has-text-right"
                  :key="uniqueid + '-from-percent-' + index"
                  :id="uniqueid + '-from-percent-' + index"
                  :grid="{ Cols: '100%', Rows: 1, Offset: 0 }"
                  :value="item.Percent"
                  @input="setField('From', index, 'Percent')($event)"
                  @nextInput="focusNextInput"
                ></FieldPercent>
              </td>
              <td>
                <fieldMoney
                  class="has-text-right"
                  :key="uniqueid + '-from-amount-' + index"
                  :id="uniqueid + '-from-amount-' + index"
                  :grid="{ Cols: '100%', Rows: 1, Offset: 0 }"
                  :value="item.Amount"
                  :decimals="2"
                  @input="setField('From', index, 'Amount')($event)"
                  @nextInput="focusNextInput"
                ></fieldMoney>
              </td>
              <td>
                <span class="remove-icon" tabindex="-1" @click="removeField('From', index)">
                  <font-awesome-icon :icon="['fa', 'trash']" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="border">
        <label style="font-weight: bold; width: 100%; margin: 0.5rem 0 0.5rem 0;">Till</label>
        <table class="no-padding no-hover">
          <thead>
            <tr>
              <th>Placering</th>
              <th>Konto</th>
              <th>Procent</th>
              <th>Belopp</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data_to" :key="index">
              <td>
                <fieldSelect
                  :key="uniqueid + '-to-instrument-' + index + '-select'"
                  :id="uniqueid + '-to-instrument-' + index + '-select'"
                  :grid="{ Cols: '100%', Rows: 1, Offset: 0 }"
                  :nativeSearch="true"
                  :options="allInstruments"
                  :value="item.InstrumentID"
                  @input="setField('To', index, 'InstrumentID')($event)"
                  @nextInput="focusNextInput"
                ></fieldSelect>
              </td>
              <td>
                <fieldSelect
                  :key="uniqueid + '-to-account-' + index + '-select'"
                  :id="uniqueid + '-to-account-' + index + '-select'"
                  :grid="{ Cols: '100%', Rows: 1, Offset: 0 }"
                  :nativeSearch="true"
                  :readonly="true"
                  :options="allAccounts"
                  :value="item.AccountID"
                  @input="setField('To', index, 'AccountID')($event)"
                  @nextInput="focusNextInput"
                ></fieldSelect>
              </td>
              <td>
                <FieldPercent
                  class="has-text-right"
                  :key="uniqueid + '-to-percent-' + index"
                  :id="uniqueid + '-to-percent-' + index"
                  :grid="{ Cols: '100%', Rows: 1, Offset: 0 }"
                  :value="item.Percent"
                  @input="setField('To', index, 'Percent')($event)"
                  @nextInput="focusNextInput"
                ></FieldPercent>
              </td>
              <td>
                <fieldMoney
                  class="has-text-right"
                  :key="uniqueid + '-to-amount-' + index"
                  :id="uniqueid + '-to-amount-' + index"
                  :grid="{ Cols: '100%', Rows: 1, Offset: 0 }"
                  :value="item.Amount"
                  :decimals="2"
                  @input="setField('To', index, 'Amount')($event)"
                  @nextInput="focusNextInput"
                ></fieldMoney>
              </td>
              <td>
                <span class="remove-icon" tabindex="-1" @click="removeField('To', index)">
                  <font-awesome-icon :icon="['fa', 'trash']" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import fieldSelect from './fieldSelect.vue'
import fieldMoney from './fieldMoney.vue'
import FieldPercent from './fieldPercent.vue'

export default {
  name: 'field-transfer',
  props: {
    error: String,
    grid: Object,
    id: String,
    value: String,
    // relatedto: String,
    // relatedtocommon: Boolean,
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      uniqueid: _.uniqueId('field-transfer-' + this.id + '-' + this.relatedto),
      data: {
        From: [],
        To: [],
        Instruments: []
      },
      allInstruments: [],
      allAccounts: [],
      emitInput: _.debounce(() => {
        const data = {
          Instruments: this.data.Instruments || [],
          From: this.data.From?.filter(item => !!item.InstrumentID) || [],
          To: this.data.To?.filter(item => !!item.InstrumentID) || []
        }

        this.$emit('input', JSON.stringify(data))
      }, 0)
    }
  },
  methods: {
    formatMoney(value) {
      const amount = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(value)
      return amount
    },
    listProvider(relatedto, relatedtocommon = false) {
      let client
      if (this.$store.getters.api === null) {
        return null
      }
      if (relatedtocommon) {
        client = this.$store.getters.api.common()
      } else {
        client = this.$store.getters.api.trust(this.$route.params.trust)
      }

      return client.listProvider(relatedto)
    },
    getInstrumentAccounts(instrumentID) {
      // Find instrument in this.data.Instruments
      const instrument = (this.data.Instruments || []).find(instr => instr.ID === instrumentID)
      if (instrument && instrument.Accounts) {
        return instrument.Accounts.map(acc => this.mapData('Account', acc))
      }
      return []
    },
    mapData(type, data) {
      switch (type) {
        case 'Account':
          return {
            Value: data.ID,
            Title: `${data.Number} - ${data.Name}`
          }
        default:
          return {
            Value: data.ID,
            Title: `${data.Name}`
          }
      }
    },
    removeField(direction, rowIndex) {
      if (this.data === null) {
        this.data = {}
      }
      if (this.data[direction] === undefined) {
        this.data[direction] = []
      }
      this.data[direction].splice(rowIndex, 1)
      this.emitInput()
    },
    setField(direction, rowIndex, fieldKey) {
      return newValue => {
        if (this.data === null) {
          this.data = {}
        }
        if (this.data[direction] === undefined) {
          this.data[direction] = []
        }
        if (this.data[direction][rowIndex] === undefined) {
          this.data[direction][rowIndex] = {}
        }

        this.$set(this.data[direction][rowIndex], fieldKey, newValue)

        // Set ControlSource if fieldKey is Amount or Percent
        if (fieldKey === 'Amount' || fieldKey === 'Percent') {
          this.$set(this.data[direction][rowIndex], 'ControlSource', fieldKey)
        }

        this.emitInput()
      }
    },
    focusNextInput(_e) {
      const focused = document.activeElement // Needs to be set before nextTick
      const table = focused?.closest('table')

      this.$nextTick(() => {
        const ref = table
        if (!ref) return
        // Find all focusable children of form
        const focusableChildren = ref.querySelectorAll(
          `:not(.disabled) > input:not([disabled]),
           :not(.disabled) > textarea:not([disabled]),
           :not(.disabled) > select:not([disabled]),
           :not(.disabled) > [tabindex]:not([tabindex = "-1"])
           :not(.vti__dropdown) > [tabindex = "0"]`
        )

        // Filter children because css selecting is limited
        const focusable = Array.prototype.filter.call(focusableChildren, function(child) {
          // if has a parent with .skip-selection, then don't focus
          if (child.closest('.skip-selection')) return false
          return true
        })

        // Convert NodeList to Array and get current focused item's index
        const focusedIndex = focusable.indexOf(focused)

        // Get next focusable item and focus it
        const current = focusable[focusedIndex]
        const next = focusable[focusedIndex + 1]

        if (next && !current?.parentNode.classList.contains('focus-submit')) {
          next.focus()
          // Select text if it's an input
          if (next.tagName === 'INPUT') {
            this.$nextTick(() => {
              next.select()
            })
          }
        } else {
          // Focus exec button
          const action = this.$refs.execButton || this.$refs.saveButton || this.$refs.createButton
          if (action) {
            action.focus()
          }
        }
      })
    }
  },
  computed: {
    instruments() {
      return (this.data.Instruments || []).map(item => ({
        Value: item.ID,
        Title: item.Name
      }))
    },
    data_from() {
      const data = this.data.From ?? []

      // Append an empty row for new entries
      data.push({ InstrumentID: '', AccountID: '', Percent: '', Amount: 0, ControlSource: '' })
      return data
    },
    data_to() {
      const data = this.data.To ?? []

      // Append an empty row for new entries
      data.push({ InstrumentID: '', AccountID: '', Percent: '', Amount: 0, ControlSource: '' })
      return data
    }
  },
  mounted() {
    // Load instruments for the select field
    const instrumentProvider = this.listProvider('Instrument', false)
    const accountProvider = this.listProvider('Account', true)

    if (instrumentProvider === null || accountProvider === null) {
      return
    }

    // Fetch all instruments
    instrumentProvider({
      filters: new Map([['Active', ['true']]]),
      sortBy: 'Name',
      sortDesc: false
    }).then(({ Results: results }) => {
      this.$set(
        this,
        'allInstruments',
        results.map(inst => this.mapData('Instrument', inst.Data))
      )
    })

    // Fetch all accounts
    accountProvider({
      filters: new Map([['CapitalAccount', ['true']]]),
      sortBy: 'Number',
      sortDesc: false
    }).then(({ Results: results }) => {
      this.$set(
        this,
        'allAccounts',
        results.map(acc => this.mapData('Account', acc.Data))
      )
    })
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue === null || newValue === undefined) {
          newValue = { From: [], To: [] }
        } else {
          newValue = JSON.parse(newValue)
        }

        this.$set(this.data, 'Instruments', _.cloneDeep(newValue.Instruments || []))
        this.$set(this.data, 'From', _.cloneDeep(newValue.From || []))
        this.$set(this.data, 'To', _.cloneDeep(newValue.To || []))
      }
    }
  },
  components: {
    fieldMoney,
    FieldPercent,
    fieldSelect
  }
}
</script>

<style scoped>
button {
  color: white;
  background-color: #ff6c6c;
  border-radius: 6px;
  border: 0;
  margin-left: 1rem;
  cursor: pointer;
}

button:hover {
  background-color: #ff4c4c;
}

table {
  overflow: visible;
}

/* Placering */
table td:nth-child(1),
table th:nth-child(1) {
  width: 50%;
  min-width: 50%;
  max-width: 50%;
}

/* Konto */
table td:nth-child(2),
table th:nth-child(2) {
  width: 50%;
  min-width: 50%;
  max-width: 50%;
}

/* Procent */
table td:nth-child(3),
table th:nth-child(3) {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

/* Belopp */
table td:nth-child(4),
table th:nth-child(4) {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
}

/* Ta bort */
table td:nth-child(5),
table th:nth-child(5) {
  width: 30px;
  min-width: 30px;
  max-width: 30px;
}

table.no-padding td {
  padding: 0;
  margin: 0;
}

.table-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.table-wrapper > * {
  flex: 1;
}

.border {
  border-radius: 4px;
  border: 1px solid #dbdbdb;
  box-shadow: inset 0 1px 2px #e6e6e6;
  /* font-size: 0.9rem; */
  padding: 0.5rem;
}

.remove-icon {
  color: #ff6c6c;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-icon:hover {
  color: #ff4c4c;
}

.has-text-right ::v-deep input {
  text-align: right;
}
</style>
